const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/teams/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { teamsDialogsSchema } from '@/components/teams/common/types';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import { getTeamsQueryOptions } from '@/lib/queries/teams/useGetTeamsQuery';
import i18n from '@/lib/translations/i18n';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
import { compactPicklistFilterSchema } from '@/lib/zod-schemas/common/compactFilterSchemas';
export const teamsSearchSchema = z.object({
  dialog: teamsDialogsSchema.optional(),
  roleId: compactPicklistFilterSchema,
  loopId: compactPicklistFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/settings/teams')({
  validateSearch: zodValidator(teamsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('edit_capacity')(ctx);
    await ensureNamespaceLoaded('teams');
  },
  loader: ({
    context: {
      queryClient
    }
  }): LoaderData => {
    queryClient.ensureQueryData(getTeamsQueryOptions());
    return {
      crumb: i18n.t($ => $.common.teams)
    };
  }
});